export type ToastKind = "success" | "error" | "warning" | "info"

export type Toast = {
  id: number
  kind: ToastKind
  message: string
}

type Listener = (toasts: Toast[]) => void

let toasts: Toast[] = []
let nextId = 1
const listeners = new Set<Listener>()

function emit() {
  for (const listener of listeners) listener(toasts)
}

export function showToast(kind: ToastKind, message: string) {
  toasts = [{ id: nextId++, kind, message }, ...toasts]
  emit()
}

export function dismissToast(id: number) {
  toasts = toasts.filter((toast) => toast.id !== id)
  emit()
}

export function subscribeToasts(listener: Listener) {
  listeners.add(listener)
  listener(toasts)
  return () => {
    listeners.delete(listener)
  }
}

/** Server flash keys and the kind of toast each one becomes. */
const FLASH_KINDS: Record<string, ToastKind> = {
  notice: "success",
  success: "success",
  alert: "error",
  error: "error",
  warning: "warning",
}

/** Shows one toast per flash message of a server response. */
export function showFlash(flash: Record<string, unknown>) {
  for (const [key, kind] of Object.entries(FLASH_KINDS)) {
    const message = flash[key]
    if (typeof message === "string" && message !== "") showToast(kind, message)
  }
}
